import { useEffect, useMemo, useState } from "react";
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { shallowEqual, useSelector } from "umi";
import { getApiData } from "@/pages/dashboard/services/common";
import { ILtvLineChartProps } from "@/pages/dashboard/pages/monetization/ltv/components/LTVLineChartCo/type";
import { dynamicString } from "@home/utils/dynamicString";
import { IComponentServiceProps, IConfigData } from "@/pages/dashboard/components/PageContainer/type";
import { stringToFunction } from "@/pages/dashboard/utils/stringToJson";
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';

export const useData = (
  api: string,
  filterVal: unknown,
  filterLoading: boolean,
  tag: string,
  beforeRequest: IComponentServiceProps['beforeRequest'] = (params) => params,
  formatData: IComponentServiceProps['formatData'],
  extraParams?: Record<string, any>,
  cycleConfig?: string | false,
) => {
  const { gameCode } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
    };
  }, shallowEqual);

  const [componentData, setComponentData] = useState({
    average_d_7_ltv: '',
    average_d_30_ltv: '',
    average_d_180_ltv: '',
    Nodes: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // 点击筛选器的时候
  useEffect(() => {
    if (!filterVal) return;
    !filterLoading && getLtvTrendDataFunc();
  }, [filterVal, tag, extraParams, cycleConfig]);

  // if (typeof config?.getParams === 'function') {
  //   params = config.getParams(params);
  // }
  // if (typeof config?.getParams === 'string') {
  //   params = stringToFunction?.(config?.getParams)?.(params);
  // }
  const getLtvTrendDataFunc = () => {
    const { rangeTime, diff, timeType, rangeDaily, ...filters } = (filterVal || {}) as Record<string, any>;
    const shouldPassCycle = cycleConfig !== false;
    const cycleValue = typeof cycleConfig === 'string' ? cycleConfig : 'day';
    let params = {
      game_code: gameCode,
      start_time: rangeTime?.[0],
      end_time: rangeTime?.[1],
      tag,
      ...(shouldPassCycle ? { cycle: cycleValue } : {}),
      period: PERIODTIMEOBJ?.[timeType] || 'daily',
      filters: formatFilterValues(filters),
    };
    if (typeof beforeRequest === 'string') {
      params = stringToFunction?.(beforeRequest)?.(params);
    }
    if (typeof beforeRequest === 'function') {
      params = beforeRequest(params);
    }
    // 合并 extraParams（如 segmentVal==='aggs' 时的 logical_flag）
    params = { ...params, ...(extraParams || {}) };
    setLoading(true);
    // api
    getApiData(api, params).then((res: any) => {
      setLoading(false);
      setError(false);

      let result = res;

      if (formatData) {
        if (typeof formatData === 'string') {
          result = stringToFunction(formatData)(result, filterVal);
        }
        if (typeof formatData === 'function') {
          result = formatData(result, filterVal);
        }
      }

      setComponentData(result);
      // setComponentData(result);
    }).catch((_err: unknown) => {
      setError(true);
      setLoading(false);
    });
  };

  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
  };
};

export const useLtvLineChartCoMemo = ({
  data,
  propsComponentMetrics,
}: {
  data: IConfigData;
  propsComponentMetrics: ILtvLineChartProps['config']['componentMetrics'];
}) => {
  const componentMetrics = useMemo(() => {
    return propsComponentMetrics.map((metric) => {
      return {
        ...metric,
        enName: dynamicString(metric.enName, data) || '',
        cnName: dynamicString(metric.cnName, data) || '',
        rangeEnName: dynamicString(metric.rangeEnName, data) || '',
        rangeCnName: dynamicString(metric.rangeCnName, data) || '',
        formatter: dynamicString(metric.formatter, data) || '',
      };
    });
  // 初始化一次即可
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    componentMetrics,
  };
};
